import NotOptimizedBrowserBanner from 'containers/Login/components/NotOptimizedBrowserBanner';
import LogoMediquoPro from 'components/icons/LogoMediquoPro';
import classnames from 'classnames';

const LoginContainer = ({ children }) => (
  <div className="bg-background">
    <NotOptimizedBrowserBanner />
    <div className="flex justify-center min-h-screen mx-auto bg-white xl:container">
      <div
        className="w-[600px] bg-primary lg:block hidden bg-cover bg-center"
        style={{ backgroundImage: "url('/images/login_background.png')" }}
      ></div>
      <div className="max-w-[564px] p-8 mx-auto">
        <LogoMediquoPro className="hidden my-5 sm:block sm:my-10 xl:my-20" />
        {children}
      </div>
    </div>
  </div>
);

const SidePanel = ({ children, bgImage, className }) => (
  <div
    className={classnames(
      'hidden flex-col max-w-xl p-6 bg-bottom bg-no-repeat lg:w-360px lg:p-10 rounded-3xl lg:flex bg-none',
      className
    )}
    style={{ backgroundImage: bgImage }}
  >
    {children}
  </div>
);

const Panel = ({ children, className = '' }) => (
  <section className={classnames('', className)}>{children}</section>
);

const Title = ({ children }) => (
  <h1 className="mb-4 text-2xl font-medium sm:text-3xl text-primary">
    {children}
  </h1>
);

const Description = ({ children, className = '' }) => (
  <p className={classnames('mb-10 text-gray-medium', className)}>{children}</p>
);

LoginContainer.SidePanel = SidePanel;
LoginContainer.Panel = Panel;
LoginContainer.Title = Title;
LoginContainer.Description = Description;

export default LoginContainer;
